<template>
  <div class="container-fluid  main-options-body">
      <div class = "row m-3 pb-2 pt-3 ">
        <router-link tag="button"  class="btn-general btn-main-options  ml-auto mr-auto " to="/containers" exact>
            EXPEDIENTES
        </router-link>
      </div>
      <div class = "row  m-3  pb-2">
        <router-link :disabled=disabled tag="button"  class="btn-general btn-main-options  ml-auto mr-auto" to="/" exact>
            LISTA DE CARGA
        </router-link>
      </div>
      <div class = "row  m-3  pb-2">
        <router-link :disabled=disabled tag="button"  class="btn-general btn-main-options  ml-auto mr-auto" to="/" exact>
            FRANJAS HORARIAS
        </router-link>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MainMenu',
  data(){
    return {
        disabled: true,
     }
  },
  computed: {
    ...mapGetters(["view_role"]),  
    ...mapGetters("user",{
      isLoggedIn: 'isLoggedIn',
      user: 'user'
    })  
  },
  mounted () {
    this.$store.commit('set_view_name', ['Menú principal'])
  },
}
</script>

<style lang= "scss" scoped>

.main-options-body > .row > img {
    height: 100%;
    margin-top: 25px;
    margin-bottom: 25px;
    max-width: 150px;
    margin-left: auto;
    margin-right: auto; 
}

</style>
